import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { LoadingOpacityContainer } from 'components/Loader/styled'
import { RowFixed } from 'components/Row'
import styled from 'styled-components'

import { ReactComponent as GasIcon } from '../../assets/svg/icons/Gas.svg'

const GasWrapper = styled(RowFixed)`
  border-radius: 8px;
  height: 20px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 14px;
  font-weight: 500;
  user-select: none;
`
export const StyledGasIcon = styled(GasIcon)`
  margin-right: 4px;
  height: 16px;
  width: 16px;
  margin-top: 2px;

  & > * {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export default function GasEstimateBadge({
  gasUseEstimateUSD,
  loading,
}: {
  gasUseEstimateUSD: CurrencyAmount<Token> // dollar amount in active chain's stablecoin
  loading: boolean
}) {
  const fixed = gasUseEstimateUSD.toFixed(2)

  const formattedGasPriceString = fixed === '0.00' ? '<$0.01' : '$' + fixed

  return (
    <LoadingOpacityContainer $loading={loading}>
      <GasWrapper style={{ marginLeft: '-0.28rem', fontSize: '12px' }}>
        <StyledGasIcon />
        {formattedGasPriceString}
      </GasWrapper>
    </LoadingOpacityContainer>
  )
}
